import ThemeCmsConstellation from "../themes/ThemeCmsConstellation.esm.js";
ThemeCmsConstellation.constellation.spacing.xs;
ThemeCmsConstellation.constellation.borderWidths.xs;
const B2B_MAIN_NAV_PADDING_VERTICAL_PX = ThemeCmsConstellation.constellation.spacing.sm;
const B2B_MAIN_NAV_LOGO_MAX_HEIGHT_PX = 44;
const B2B_MAIN_NAV_BORDER_WIDTH_PX = ThemeCmsConstellation.constellation.borderWidths.xs;
const B2B_MAIN_NAV_HEIGHT_PX = B2B_MAIN_NAV_PADDING_VERTICAL_PX * 2 + B2B_MAIN_NAV_LOGO_MAX_HEIGHT_PX + B2B_MAIN_NAV_BORDER_WIDTH_PX;
const STICKY_SIDEBAR_TOP_PX = B2B_MAIN_NAV_HEIGHT_PX + ThemeCmsConstellation.constellation.spacing.md;
export {
  B2B_MAIN_NAV_BORDER_WIDTH_PX,
  B2B_MAIN_NAV_HEIGHT_PX,
  B2B_MAIN_NAV_LOGO_MAX_HEIGHT_PX,
  B2B_MAIN_NAV_PADDING_VERTICAL_PX,
  STICKY_SIDEBAR_TOP_PX
};
